/* ============================================================
   ILS — Live "This Week Current Leader" patcher (TASK-2045).

   Fetches the current weekly-leader amount from the same
   Cloudflare Worker the live ilovesnacks.eu site reads:
     GET https://wild-surf-911e.konstantinsbratuskins-lv.workers.dev/current
     → {"total": "135.92"}

   Paints two slots (either can be absent — script no-ops on the missing one):
     - Homepage giveaway section:  #weekly_leader_amount
     - Cart drawer header row:     [data-ils-cd-leader-row] +
                                   [data-ils-cd-leader] +
                                   the data-ils-cd-leader-original attribute
                                   (source of truth for custom-cart-drawer.js —
                                   its renderLeaderState() reads it to restore
                                   the label when the cart drops out of the
                                   leading state).

   Guardrails:
     - We do NOT overwrite [data-ils-cd-leader] textContent while the cart is
       in the "leading" state (label reads "YOU are…") — that slot then
       carries the shopper's live cart total, not the leader. The attribute
       update is enough; cart-drawer.js will paint the correct new value on
       the next state transition.
     - Fetch failures / non-positive totals leave the Liquid fallback in
       place (€0,00 default or shop.metafields.custom.weekly_leader_amount).
     - Polls every 30 s while the tab is visible so a leader change made
       during a session shows up without a reload.
   ============================================================ */
(function () {
  'use strict';

  var LEADER_URL = 'https://wild-surf-911e.konstantinsbratuskins-lv.workers.dev/current';
  var POLL_MS = 30000;

  /* TASK-2116 — publish a one-shot "live leader has settled" signal so
     custom-cart-drawer.js can hold its first renderLeaderState() until the
     authoritative leader value is in the DOM, instead of racing the stale
     Liquid/metafield fallback. Fires once, on the first fetch attempt
     (success OR failure). Consumers can await either window.ILS._leaderLiveDone
     or the 'ils:leader-live-ready' document event. */
  var _liveReadyFired = false;
  function markLiveReady() {
    if (_liveReadyFired) return;
    _liveReadyFired = true;
    window.ILS = window.ILS || {};
    window.ILS._leaderLiveDone = true;
    try {
      document.dispatchEvent(new CustomEvent('ils:leader-live-ready'));
    } catch (e) {}
  }

  /* TASK-4846 — ONE global money format on EVERY published locale,
     English included: decimal separator ',' and thousands separator '.'
     (€0,00 / €89,90 / €1.234,56). Deliberately not Intl.NumberFormat or
     toLocaleString: this is a storefront business rule, not a locale
     convention, and en-* would render €1,234.56. Same algorithm as
     moneyFromCents() in custom-cart-drawer.js. Presentation only — the
     numeric value and its rounding are untouched. */
  function formatEur(total) {
    var n = parseFloat(total);
    if (!isFinite(n) || n <= 0) return '';   // unchanged guard
    /* TASK-5856 — REPORT-5848 D5. The Cloudflare Worker publishes the leader's
       basket in EUR and this printed it with a euro sign on every market, so a
       Swedish shopper read "€135,92" beside a kr cart. The leader is a reported
       FACT, not a target, so it is converted at the oracle's rate and formatted
       in the market's own money format without being rounded up a grid.

       THE NUMBER CHANNEL. publishLeaderEur() below keeps the raw EUR value on
       window.ILS._leaderEurValue because custom-cart-drawer.js (getLeaderEur)
       and custom-cart-page.js (renderPageLeaderState) used to recover this value
       by PARSING the string back. Localising the string without that channel
       would have silently made the leader comparison presentment-vs-EUR — which
       is the TASK-5795 defect, in the one surface that awards a bonus. */
    publishLeaderEur(n);
    var R = window.ILSRewardMatrix;
    if (R && typeof R.eurMoney === 'function') {
      try { var s = R.eurMoney(n); if (s !== null) return s; } catch (e) {}
    }
    var cents = Math.round(n * 100);
    var frac = String(cents % 100);
    while (frac.length < 2) frac = '0' + frac;
    /* TASK-5946 — display only: a FULLY zero fraction prints as no fraction. */
    return '€' + String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (frac === '00' ? '' : ',' + frac);
  }

  /* The EUR number behind the painted string. Written on every successful
     format, so it can never be staler than the text beside it. */
  function publishLeaderEur(eur) {
    try {
      window.ILS = window.ILS || {};
      window.ILS._leaderEurValue = (isFinite(eur) && eur > 0) ? Number(eur) : null;
    } catch (e) {}
  }

  /* TASK-2121 — expose the last successful live leader value so consumers
     (custom-cart-drawer.js's morphCartDrawer + hydrateLeader) can re-apply
     it to the DOM after a cart-drawer morph resets the row's
     data-ils-cd-leader-original attribute to the stale Liquid fallback.
     Prior behaviour let the fallback (e.g. "€0,00") flash for up to 30s
     until the next poll fetched the live value. */
  function paint(value) {
    if (!value) return;
    window.ILS = window.ILS || {};
    window.ILS._leaderLiveValue = value;

    var onPage = document.getElementById('weekly_leader_amount');
    if (onPage && onPage.textContent.trim() !== value) {
      onPage.textContent = value;
    }

    var row = document.querySelector('[data-ils-cd-leader-row]');
    var amt = document.querySelector('[data-ils-cd-leader]');
    if (row) {
      row.setAttribute('data-ils-cd-leader-original', value);
      if (row.hidden) row.hidden = false;
    }
    if (amt) {
      var lbl = document.querySelector('[data-ils-cd-leader-lbl]');
      var inLeadingUi = lbl && lbl.textContent.indexOf('YOU are') === 0;
      if (!inLeadingUi && amt.textContent.trim() !== value) {
        amt.textContent = value;
      }
    }
  }

  window.ILS = window.ILS || {};
  window.ILS.applyLeaderLive = function () {
    var v = window.ILS && window.ILS._leaderLiveValue;
    if (v) paint(v);
  };

  function fetchLeader() {
    return fetch(LEADER_URL, { credentials: 'omit', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || typeof data !== 'object') return;
        var value = formatEur(data.total);
        if (value) paint(value);
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[ils-weekly-leader-live] fetch failed - keeping Liquid fallback.', err);
        }
      })
      .then(markLiveReady, markLiveReady);
  }

  var pollTimer = null;
  function startPoll() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      if (document.visibilityState !== 'hidden') fetchLeader();
    }, POLL_MS);
  }

  function init() {
    var hasHomeSlot = !!document.getElementById('weekly_leader_amount');
    var hasCartSlot = !!document.querySelector('[data-ils-cd-leader]');
    if (!hasHomeSlot && !hasCartSlot) {
      /* No leader slots on this page → publish the ready signal anyway so
         any waiting consumer (custom-cart-drawer.js) doesn't have to burn
         its full timeout. */
      markLiveReady();
      return;
    }
    fetchLeader();
    startPoll();
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') fetchLeader();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
